export const notCustomer =["ADMIN","PROVIDER"];
